<template>
    <div v-if="isValidRoute">
        <!--面包屑导航区域-->
        <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/index' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/stores' }">门店管理</el-breadcrumb-item>
            <el-breadcrumb-item>编辑门店</el-breadcrumb-item>
        </el-breadcrumb>
            <!--卡片视图区-->
            <el-card>
                <el-form :model="editForm" :rules="editFormRules" ref="editFormRef"  label-width="130px" class="store-form" style="width:90%;margin:10px auto">
                    <el-form-item label="门店名称" prop="storename">
                        {{ editForm.storename}}
                    </el-form-item>
                  <el-form-item label="门店照片" prop="goods_pic">
                    <el-upload
                        ref="imgBroadcastUpload"
                        :limit="limitNum"
                        :auto-upload="true"
                        :file-list="fileList"
                        :on-success="editPic"
                        list-type="picture-card"
                        accept=".jpg,.png"
                        :before-upload="beforePicUpload"
                        :action="uploadurl">
                      <i class="el-icon-plus"></i>
                      <div slot="tip" class="el-upload__tip">只能上传jpg/png文件，且不超过2M</div>
                    </el-upload>
                  </el-form-item>
                  <el-row :gutter="10">
<!--                    <el-col :span="12">-->
<!--                      <el-form-item label="操房数量" prop="roomnum">-->
<!--                        <el-input v-model="editForm.roomnum" >-->
<!--                          <template slot="append">间</template>-->
<!--                        </el-input>-->
<!--                      </el-form-item>-->
<!--                    </el-col>-->
                    <el-col :span="12">
                      <el-form-item label="门店面积" prop="storearea">
                        <el-input v-model="editForm.storearea"  >
                          <template slot="append">㎡</template>
                        </el-input>
                      </el-form-item>
                    </el-col>

<!--                    <el-col :span="12">-->
<!--                      <el-form-item label="器械种类" prop="devicetype">-->
<!--                        <el-input v-model="editForm.devicetype" placeholder="请输入正整数" @input="editForm.devicetype = onlyPositiveInt($event)" >-->
<!--                          <template slot="append">种</template>-->
<!--                        </el-input>-->
<!--                      </el-form-item>-->
<!--                    </el-col>-->

                    <el-col :span="12">
                      <el-form-item label="店内Wifi" prop="wifi">
                        <el-input v-model="editForm.wifi" ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="10">
                    <el-col :span="24">
                      <el-form-item label="门店服务" prop="serviceTags" v-permission="'btn:store:field:services'">
                        <!-- 自定义标签池：勾选按原样式，管理按钮挂在最后一组末尾（空池时 serviceRows=[[]]，按钮仍有处挂） -->
                        <el-checkbox-group v-model="selectedServiceUids">
                          <div v-for="(row, ri) in serviceRows" :key="ri" class="tag-row">
                            <span v-if="row.length === 0" class="tag-empty">暂未提供</span>
                            <el-checkbox v-for="item in row" :key="item.uid" :label="item.uid"
                                         :disabled="isServiceTagFull(item)"
                                         :title="isServiceTagFull(item) ? '门店服务最多选择 6 个' : ''">{{ item.name }}</el-checkbox>
                            <el-button
                              v-if="ri === serviceRows.length - 1"
                              type="text" icon="el-icon-setting" class="tag-manage-btn"
                              @click="openTagDialog(1)">自定义标签管理</el-button>
                          </div>
                        </el-checkbox-group>
                      </el-form-item>
                    </el-col>
                    <el-col :span="24">
                      <el-form-item label="设施设备" prop="facilityTags" v-permission="'btn:store:field:facilities'">
                        <el-checkbox-group v-model="selectedFacilityUids">
                          <div v-for="(row, ri) in facilityRows" :key="ri" class="tag-row">
                            <span v-if="row.length === 0" class="tag-empty">暂未提供</span>
                            <el-checkbox v-for="item in row" :key="item.uid" :label="item.uid">{{ item.name }}</el-checkbox>
                            <el-button
                              v-if="ri === facilityRows.length - 1"
                              type="text" icon="el-icon-setting" class="tag-manage-btn"
                              @click="openTagDialog(2)">自定义标签管理</el-button>
                          </div>
                        </el-checkbox-group>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="10">

                    <el-col :span="12">
                      <el-form-item label="门店简介" prop="jianjie">
                        <el-input v-model="editForm.jianjie" type="textarea" :rows="3" maxlength="100" show-word-limit ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="10">
                    <el-col :span="12">
                      <el-form-item label="设备类型" prop="newFlag">
                        <el-radio-group v-model="editForm.newFlag" @change="handleFlagChange('flag')">
                          <el-radio :label="'N'">旧设备</el-radio>
                          <el-radio :label="'Y'">新设备</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="抖音门店ID" prop="dystoreid">
                        <el-input v-model="editForm.dystoreid"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="高德门店ID" prop="gaodestoreid">
                        <el-input v-model="editForm.gaodestoreid"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="10">
                    <el-col :span="12">
                      <el-form-item label="状态" prop="isopen">
                        <el-select  v-model="editForm.isopen"  placeholder="请选择状态" @change="handleFlagChange('isopen')" style="width:100%">
                          <el-option v-for="item in statuslist" :key="item.id" :label="item.status" :value="item.id"></el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="歇业日期">
                        <el-date-picker
                            v-model="xyDates"
                            style="width:100%"
                            type="daterange"
                            range-separator="至"
                            start-placeholder="开始日期"
                            end-placeholder="结束日期">
                        </el-date-picker>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="10">
                    <el-col :span="12">
                      <el-form-item label="开始时间" prop="openStoreTime">
                        <el-time-picker
                            v-model="editForm.openStoreTime"
                            @change="handleOpenStoreTime"
                            style="width:100%"
                            placeholder="开始时间">
                        </el-time-picker>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="结束时间" prop="closeStoreTime">
                        <el-time-picker
                            v-model="editForm.closeStoreTime"
                            @change="handleOpenStoreTime"
                            style="width:100%"
                            placeholder="结束时间">
                        </el-time-picker>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="10">
                    <el-col :span="12">
                      <el-form-item label="客服微信" prop="wechat">
                        <el-input v-model="editForm.wechat"  ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="客服电话" prop="telephone">
                        <el-input v-model="editForm.telephone"  ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="10">
                    <el-col :span="12">
                      <el-form-item label="门店序号" prop="xh">
                        <el-input v-model="editForm.xh"  ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="音乐TOPIC" prop="musicTopic">
                        <el-input v-model="editForm.musicTopic"  ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="10">
                    <el-col :span="12">
                      <el-form-item label="大屏TOPIC" prop="dashboardTopic">
                        <el-input v-model="editForm.dashboardTopic" ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="10">
                    <el-col :span="12">
                      <el-form-item label="店主数量" prop="ownerNum">
                        <el-input v-model="editForm.ownerNum"  ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="店长数量" prop="managerNum">
                        <el-input v-model="editForm.managerNum"  ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="10">
                    <el-col :span="12">
                      <el-form-item label="店员数量" prop="associateNum">
                        <el-input v-model="editForm.associateNum"  ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="保洁数量" prop="clearNum">
                        <el-input v-model="editForm.clearNum"  ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="10">
                    <el-col :span="12">
                      <el-form-item label="保洁每月可改次数" prop="settingNum">
                        <el-input v-model="editForm.settingNum"  ></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="10">
                    <el-col :span="12">
                      <el-form-item label="用户停卡" prop="stopCard">
                        <el-radio-group v-model="editForm.stopCard">
                          <el-radio :label="'0'">开启</el-radio>
                          <el-radio :label="'1'">关闭</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="10">
                    <el-col :span="12">
                      <el-form-item label="进店1Sn" prop="sn">
                        <el-input v-model="editForm.sn" ></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="出店1Sn" prop="outsn">
                        <el-input v-model="editForm.outsn"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="10">
                    <el-col :span="12">
                      <el-form-item label="进店2Sn" prop="sn1">
                        <el-input v-model="editForm.sn1" @change="handleTwoDoorChange"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="出店2Sn" prop="outsn1">
                        <el-input v-model="editForm.outsn1" @change="handleTwoDoorChange"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="10">
                    <el-col :span="12">
                      <el-form-item label="鱼眼1Sn" prop="fishsn">
                        <el-input v-model="editForm.fishsn"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="鱼眼2Sn" prop="fishsn1">
                        <el-input v-model="editForm.fishsn1"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="10" v-if="editForm.isNewZhuapai === '0'">
<!--                  <el-row :gutter="10">-->
                    <el-col :span="12">
                      <el-form-item label="摄像头1Sn" prop="camera1">
                        <el-input v-model="editForm.camera1"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="摄像头2Sn" prop="camera2">
                        <el-input v-model="editForm.camera2"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="10" v-if="editForm.isNewZhuapai === '0'">
<!--                  <el-row :gutter="10">-->
                    <el-col :span="12">
                      <el-form-item label="摄像头3Sn" prop="camera3">
                        <el-input v-model="editForm.camera3"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="摄像头4Sn" prop="camera4">
                        <el-input v-model="editForm.camera4"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="10" v-if="editForm.isNewZhuapai === '1'">
                    <el-col :span="12">
                      <el-form-item label="录像机IP" prop="lxjIp">
                        <el-input v-model="editForm.lxjIp"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="摄像头数量" prop="zhuapaiNum">
                        <el-input v-model="editForm.zhuapaiNum"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="10" v-if="editForm.newFlag === 'N'">
                    <el-col :span="12">
                      <el-form-item label="边缘盒子Sn" prop="boxsn">
                        <el-input v-model="editForm.boxsn"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="温湿度Sn" prop="wsdsn">
                        <el-input v-model="editForm.wsdsn"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row :gutter="10" v-if="editForm.newFlag === 'Y'">
                    <el-col :span="12">
                      <el-form-item label="人脸类型" prop="faceLocal">
                        <el-radio-group v-model="editForm.faceLocal">
                          <el-radio :label="'N'">线上</el-radio>
                          <el-radio :label="'Y'">本地</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="抓拍类型" prop="isNewZhuapai">
                        <el-radio-group v-model="editForm.isNewZhuapai" @change="handleZhapaiChange">
                          <el-radio :label="'0'">京目</el-radio>
                          <el-radio :label="'1'">海康</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row :gutter="10" v-if="editForm.faceLocal === 'Y'">
                    <el-col :span="12">
                      <el-form-item label="人脸识别" prop="faceDeviceType">
                        <el-radio-group v-model="editForm.faceDeviceType">
                          <el-radio :label="'0'">大华</el-radio>
                          <el-radio :label="'1'">旧设备</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="通信方式" prop="optModel">
                        <el-radio-group v-model="editForm.optModel">
                          <el-radio :label="'0'">UDP</el-radio>
                          <el-radio :label="'1'">串口</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row :gutter="10" v-if="editForm.newFlag === 'Y'">
                    <el-col :span="12">
                      <el-form-item label="继电器类型" prop="controlType">
                        <el-radio-group v-model="editForm.controlType" @change="handleControlTypeChange">
                          <el-radio :label="'0'">科星</el-radio>
                          <el-radio :label="'1'">泥人</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12" v-if="editForm.controlType === '1'">
                      <el-form-item label="泥人IP" prop="controlIp">
                        <el-input v-model="editForm.controlIp"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="10" v-if="editForm.newFlag === 'Y'">
                    <el-col :span="12">
                      <el-form-item label="上位机TOPIC" prop="upDeviceTopic">
                        <el-input v-model="editForm.upDeviceTopic"  style="width:100%"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="上位机TOPIC2" prop="upDeviceTopic2">
                        <el-input v-model="editForm.upDeviceTopic2"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="10" v-if="editForm.newFlag === 'Y'">
                    <el-col :span="12">
                      <el-form-item label="淋浴时长" prop="lyTime">
                        <el-input v-model="editForm.lyTime">
                          <template slot="append">分钟</template>
                        </el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="AB门类型" prop="doorType">
                        <el-radio-group v-model="editForm.doorType">
                          <el-radio :label="'0'">正常</el-radio>
                          <el-radio :label="'1'">单机器双门</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="10" v-if="editForm.newFlag === 'Y'">
                    <el-col :span="12">
                      <el-form-item label="AB门IP" prop="doorIp">
                        <el-input v-model="editForm.doorIp"  style="width:100%"></el-input>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="第二门IP" prop="doorIp2">
                        <el-input v-model="editForm.doorIp2"  style="width:100%"></el-input>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row :gutter="10" v-if="editForm.openStoreTime || editForm.closeStoreTime">
                    <el-col :span="12">
                      <el-form-item label="闭店类型" prop="closeStatus">
                        <el-radio-group v-model="editForm.closeStatus" @change="handleCloseStatusChange">
                          <el-radio :label="item.val" v-for="(item, index) in closeTypes" :key="index">{{ item.text }}</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item label="24小时门" prop="openDoor" v-if="editForm.closeStatus == '1'">
                        <el-radio-group v-model="editForm.openDoor">
                          <el-radio :label="item.val" v-for="(item, index) in doors" :key="index">{{ item.text }}</el-radio>
                        </el-radio-group>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-form-item label="继电器" v-if="editForm.newFlag === 'Y'">
                    <el-button
                        type="primary"
                        plain
                        icon="el-icon-plus"
                        size="mini"
                        @click="handleAddRelay"
                    >新增</el-button>
                    <el-table :data="controls" height="250" border style="width: 100%">
                      <el-table-column type="index" label="序号" width="100" align="center"/>
                      <el-table-column prop="name" label="名称" align="center">
                        <template slot-scope="scope">
                          <el-input v-model="scope.row.name"  style="width:100%"></el-input>
                        </template>
                      </el-table-column>
                      <el-table-column prop="relayNum" label="端口" align="center">
                        <template slot-scope="scope">
                          <el-select v-model="scope.row.relayNum" clearable placeholder="请选择">
                            <el-option
                                v-for="item in filterRelays(scope.row.relayNum)"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value">
                            </el-option>
                          </el-select>
                        </template>
                      </el-table-column>
                      <el-table-column prop="autoFlag" label="自动运行" align="center">
                        <template slot-scope="scope">
                          <el-switch
                              onchange="handleAutoChange(scope.row)"
                              v-model="scope.row.autoFlag"
                              active-color="#13ce66"
                              inactive-color="#ff4949"
                              active-value="1"
                              inactive-value="0">
                          </el-switch>
                        </template>
                      </el-table-column>
                      <el-table-column prop="autoFlag" label="自动类型" align="center">
                        <template slot-scope="scope">
                          <el-radio-group @change="handleAutoTypeChange(scope.row)" v-model="scope.row.autoType" v-if="scope.row.autoFlag === '1'">
                            <el-radio :label="'0'">定时</el-radio>
                            <el-radio :label="'1'">系统</el-radio>
                          </el-radio-group>
                        </template>
                      </el-table-column>
                      <el-table-column label="开始时间" align="center" width="300">
                        <template slot-scope="scope">
                          <el-time-picker
                              v-if="scope.row.autoType === '0'"
                              v-model="scope.row.startTime"
                              placeholder="开始时间">
                          </el-time-picker>
                        </template>
                      </el-table-column>
                      <el-table-column label="结束时间" align="center" width="300">
                        <template slot-scope="scope">
                          <el-time-picker
                              v-if="scope.row.autoType === '0'"
                              v-model="scope.row.endTime"
                              placeholder="结束时间">
                          </el-time-picker>
                        </template>
                      </el-table-column>
                      <el-table-column label="操作" align="center" width="100">
                        <template slot-scope="scope">
                          <el-button type="primary" @click="handleDeleteRelay(scope.$index)">删除</el-button>
                        </template>
                      </el-table-column>
                    </el-table>
                  </el-form-item>
                  <el-form-item label="淋浴继电器" v-if="editForm.newFlag === 'Y'">
                    <el-button
                        type="primary"
                        plain
                        icon="el-icon-plus"
                        size="mini"
                        @click="handleAddLy"
                    >新增</el-button>
                    <span style="color: red; font-size: 12px;margin-left: 10px">注：一个继电器最多绑定4个淋浴间</span>
                    <el-row :gutter="10" style="margin-bottom: 15px" :key="i" v-for="(ly, i) in lyRelays">
                      <el-col :span="18">
                        <el-input placeholder="请输入IP:PORT" v-model="ly.lyIp">
                          <template slot="prepend">UDP地址</template>
                        </el-input>
                      </el-col>
                      <el-col :span="6">
                        <el-button @click="handleDelLy(i)" v-if="ly.editFlag === 'Y'" type="danger" icon="el-icon-delete" circle></el-button>
                      </el-col>
                    </el-row>
                  </el-form-item>

                    <!-- 备注：非必填，管理员可见的内部说明（字段 store_info.remark） -->
                    <el-form-item label="备注" prop="remark" class="remark-item">
                      <el-input
                          v-model="editForm.remark"
                          type="textarea"
                          :rows="3"
                          maxlength="255"
                          show-word-limit
                          resize="none"
                          placeholder="请输入备注（选填，最多255字）"
                      ></el-input>
                    </el-form-item>

                    <el-form-item>
                        <el-button @click="handleCancel">取 消</el-button>
                        <el-button type="primary" @click="EditStoreSave" v-loading="btnLoading" v-permission="'btn:store:update'">确 定</el-button>
                    </el-form-item>
                </el-form>

            <!-- 自定义标签管理弹窗：store-id 非空，内部保存即调 /storetag/save 落库，本页只接 saved -->
            <tag-manage-dialog
                :visible.sync="dialogVisible"
                :tag-type="dialogTagType"
                :store-id="tagDialogStoreId"
                :tags="dialogTagType === 1 ? serviceTags : facilityTags"
                :selected-uids="dialogTagType === 1 ? selectedServiceUids : selectedFacilityUids"
                :refreshing="refreshingTags"
                :highlight-names="dialogHighlightNames"
                @saved="onTagSaved"
            ></tag-manage-dialog>
        </el-card>
    </div>
</template>
<script>
// import TxMap from "../../components/common/TXMap"
import {cities, fetchCities} from '@/assets/js/city.js'
import TagManageDialog from './TagManageDialog.vue'

export default {
    components: { TagManageDialog },
    data(){
        return {
          btnLoading: false,
            // 自定义标签池（全量定义，每行带 uid）。勾选态单独放 data 顶层，不进 editForm
            serviceTags: [],
            facilityTags: [],
            selectedServiceUids: [],
            selectedFacilityUids: [],
            // 给"进入页面"的标签发 tmp_x；只在发新号时递增
            tagSeed: 0,
            dialogVisible: false,
            dialogTagType: 1,
            refreshingTags: false,
            dialogHighlightNames: [],
            imgURL:this.GLOBAL.imgURL,
            uploadurl: this.GLOBAL.imgURL+'upload/',
            limitNum: 1,
            fileList:[],
            cities:cities,
            citylist:[],
            statuslist:[],
            id:'',
            isValidRoute: false, // 添加一个标志，表示当前是否是有效的编辑门店路由
            //编辑表单数据
            editForm:{
                // storename:'',
                // city:'',
                // address:'东营市',
                // localtion:'',
                // prov_name: "",
                // city_name: "",
                // district_name: "",
                // latitude:'',
                // longitude:'',
                // storepic:'',
                roomnum:'',
                storearea:'',
                devicetype:'',
                wechat:'',
                telephone:'',
                wifi:'',
                jianjie:'',
                isopen:1,
                sn:'',
                outsn:'',
                sn1:'',
                outsn1:'',
                camera1:'',
                camera2:'',
                camera3:'',
                camera4:'',
                fishsn:'',
                fishsn1:'',
                boxsn:'',
                wsdsn:'',
                newFlag: 'N',
                faceDeviceType: '1',
                upDeviceTopic: '',
                upDeviceTopic2: '',
                lyTime: null,
                xh: null,
                doorIp: null,
                doorIp2: null,
                controlType: '0',
                controlIp: null,
                faceLocal: 'N',
                isNewZhuapai: '0',
                zhuapaiNum: null,
                lxjIp: null,
                openStoreTime: null,
                closeStoreTime: null,
                doorType: '0',
              optModel: '0',
              stopCard: '0',
              city: null,
              tyStartTime: null,
              tyStopTime: null,
              closeStatus: null,
              openDoor: null,
              musicTopic: null,
              dashboardTopic: null,
              clearNum: null,
              settingNum: null,
              associateNum: null,
              ownerNum: null,
              managerNum: null,
              // 备注(store_info.remark):非必填,管理员可见的内部说明
              remark: null
            },
          xyDates: [],
          closeTypes: [
            {
              val: '0',
              text: '限制进入'
            }
          ],
          doors: [
            {
              val: '0',
              text: '第一门'
            },
            {
              val: '1',
              text: '第二门'
            }
          ],
          controls: [],
          lyRelays:[],
          //编辑表单验证规则
          editFormRules:{
            xh:[
                { pattern: /^[1-9]\d{0,8}$/, message: '门店序号只能是数字必须以1-9开头', trigger: 'blur' }
            ],
            clearNum:[
              { pattern: /^[1-9]\d?$/, message: '保洁数量只能是整数', trigger: 'blur' }
            ],
            associateNum:[
              { pattern: /^[1-9]\d?$/, message: '店员数量只能是整数', trigger: 'blur' }
            ],
            ownerNum:[
              { pattern: /^[1-9]\d?$/, message: '店主数量只能是整数', trigger: 'blur' }
            ],
            managerNum:[
              { pattern: /^[1-9]\d?$/, message: '店长数量只能是整数', trigger: 'blur' }
            ],
            settingNum:[
              { pattern: /^[1-9]\d?$/, message: '保洁每月可改次数只能是整数', trigger: 'blur' }
            ],
            storename:[
                { required: true, message: '请选输入门店名称', trigger: 'blur' }
            ],
            city:[
                { required: true, message: '请选择所属城市', trigger: 'blur' }
            ],
            address:[
                { required: true, message: '请选择门店地址', trigger: 'blur' }
            ],
            localtion:[
                { required: true, message: '请标注门店位置', trigger: 'blur' }
            ],
            isopen:[
                { required: true, message: '请选择店铺状态', trigger: 'blur' }
            ],
            upDeviceTopic:[],
            upDeviceTopic2:[
              { max: 50, message: '最大长度为50字符', trigger: 'change' }
            ],
            lyTime:[],
            doorIp: [
              { pattern: /^(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3}):(\d{1,6})$/, message: 'IP格式IP:PORT', trigger: 'blur' }
            ],
            doorIp2: [
              { pattern: /^(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3}):(\d{1,6})$/, message: 'IP格式IP:PORT', trigger: 'blur' }
            ],
            controlIp: [
              { pattern: /^(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3}):(\d{1,6})$/, message: 'IP格式IP:PORT', trigger: 'blur' }
            ],
            lxjIp: [
              { pattern: /^(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3})$/, message: 'IP格式XXX.XXX.XXX', trigger: 'blur' }
            ],
            zhuapaiNum: [
              { pattern: /^[1-9]\d{0,8}$/, message: '抓拍数量只能是数字必须以1-9开头', trigger: 'blur' }
            ],
            devicetype: [
              { pattern: /^[1-9]\d{0,8}$/, message: '器械种类只能输入正整数', trigger: 'blur' }
            ]
          },
          relayNums: [
            {
              value: 0,
              label: '端口一'
            },
            {
              value: 1,
              label: '端口二'
            },
            {
              value: 2,
              label: '端口三'
            },
            {
              value: 3,
              label: '端口四'
            },
            {
              value: 4,
              label: '端口五'
            },
            {
              value: 5,
              label: '端口六'
            },
            {
              value: 6,
              label: '端口七'
            },
            {
              value: 7,
              label: '端口八'
            },
            {
              value: 8,
              label: '端口九'
            },
            {
              value: 9,
              label: '端口十'
            },
            {
              value: 10,
              label: '端口十一'
            },
            {
              value: 11,
              label: '端口十二'
            },
            {
              value: 12,
              label: '端口十三'
            },
            {
              value: 13,
              label: '端口十四'
            },
            {
              value: 14,
              label: '端口十五'
            },
            {
              value: 15,
              label: '端口十六'
            }
          ],
          nrRelayNums: [
            {
              value: 1,
              label: '端口一'
            },
            {
              value: 2,
              label: '端口二'
            },
            {
              value: 3,
              label: '端口三'
            },
            {
              value: 4,
              label: '端口四'
            },
            {
              value: 5,
              label: '端口五'
            },
            {
              value: 6,
              label: '端口六'
            },
            {
              value: 7,
              label: '端口七'
            },
            {
              value: 8,
              label: '端口八'
            }
          ],
          oldLyRelay: [],
          updateSign: false
        }
    },
    computed:{
      // 标签池按 10 个一组切行；空池必须返回 [[]] —— 否则「自定义标签管理」按钮没有挂载点
      serviceRows(){
        const rows = this.chunk(this.serviceTags, 10)
        return rows.length ? rows : [[]]
      },
      facilityRows(){
        const rows = this.chunk(this.facilityTags, 10)
        return rows.length ? rows : [[]]
      },
      // 弹窗用的 Number 型门店 id：有值即「保存落库」，null 走「只回传草稿」（仅 Add 页该走）。
      // 路由参数是权威来源，this.id 只是 created 回填的副本；⚠️ 不能只认 this.id ——
      // 它一旦为空串，弹窗会退化成不落库的草稿模式，且打开时不发请求
      tagDialogStoreId(){
        const raw = this.id || (this.$route && this.$route.params && this.$route.params.id) || ''
        return raw ? Number(raw) : null
      }
    },
    created(){
        // 验证当前路由是否是编辑门店页面
        this.validateRoute();

        // 如果不是有效路由，直接返回
        if (!this.isValidRoute) {
            return;
        }

        // 加载门店数据（id已在validateRoute中设置）
        this.getCityList();
        this.editStore();
        this.getStatusList();
    },

    // 移除路由监听器，避免在导航到其他页面时触发验证
    beforeRouteUpdate(to, from, next) {
        // 只在当前组件内部路由更新时才执行
        if (to.path.startsWith('/storeedit/')) {
            this.validateRoute();
        }
        next();
    },

    mounted(){
    },
    methods:{
      filterRelays(val){
        let arr = this.controls.map(item=> item.relayNum)
        if (this.editForm.controlType == '0') {
          return this.relayNums.filter(relay => arr.indexOf(relay.value) === -1 || relay.value === val)
        } else {
          return this.nrRelayNums.filter(relay => arr.indexOf(relay.value) === -1 || relay.value === val)
        }
      },
      // 验证当前路由是否是编辑门店页面
      validateRoute() {
          try {
              // 获取当前路由参数
              const storeId = this.$route.params.id;

              // 如果参数不是数字，说明这不是编辑门店页面，而是其他菜单项
              if (!storeId || isNaN(Number(storeId))) {
                  // 如果不是数字，则应该是其他菜单项，直接跳转到相应页面
                  console.log('检测到非数字参数，应该是其他菜单项:', storeId);
                  this.isValidRoute = false;

                  // 如果是其他菜单项，则跳转到相应页面
                  if (storeId && typeof storeId === 'string') {
                      setTimeout(() => {
                          window.location.href = window.location.origin + window.location.pathname + '#/' + storeId;
                      }, 0);
                  }
                  return;
              }

              // 如果是数字，则是编辑门店页面，设置为有效路由
              this.isValidRoute = true;
              this.id = storeId;
          } catch (error) {
              console.error('路由验证错误:', error);
              this.isValidRoute = false;
          }
      },

        async getCityList(){
            await fetchCities();
            const transformedData = this.cities.map(city => {
                const cityObject = {
                    value: city.name,
                    label: city.name,
                    children: city.districts ? city.districts.map(district => ({
                        value: district,
                        label: district
                    })) : []
                };
                return cityObject;

            });
            this.citylist = transformedData
        },
        async getStatusList(){
            const { data: res } = await this.$http.get('status/')
            this.statuslist = res.data
        },
        // 服务标签最多勾 6 个，勾满后其余未勾选项置灰（已勾选的不禁，否则取消不掉）。
        // 6 对应后端 StoreConstants.SERVICE_TAG_MAX_SELECTED，改那边须同步这里
        isServiceTagFull(item){
          return this.selectedServiceUids.length >= 6 && this.selectedServiceUids.indexOf(item.uid) < 0
        },
        // 给每行补 uid（Edit 用 id_xxx 确定性、Add 用 tmp_N 自增），只在进页面时算一次。
        // ⚠️ 不能每次打开弹窗重算 —— 已勾选存的 uid 会全部悬空，勾选凭空消失
        attachUid(list){
          return (list || []).map(t => ({
            ...t,
            uid: t.uid || (t.id != null ? 'id_' + t.id : 'tmp_' + (++this.tagSeed))
          }))
        },
        // 按 10 个一组切行：唯一硬要求是空数组返回 [[]]，否则管理按钮无处挂载
        chunk(list, size){
          const out = []
          for (let i = 0; i < (list || []).length; i += size) out.push(list.slice(i, i + size))
          return out
        },
        // 打开标签管理弹窗：先弹层再拉最新池（弹窗立即可见，列表区转 loading）。
        // 每次打开都重拉 —— 保存是「整份覆盖 + 物理删除」，拿页面旧池去 diff 会误删他人新增的行
        openTagDialog(tagType){
          // 无门店 ID 时不提供弹窗：弹窗内 storeId 为空会退化成「只回传草稿、不落库」，
          // 保存后界面上与成功无异，刷新即丢
          if (!this.tagDialogStoreId) {
            this.$message.error('未取到门店 ID，请回到门店列表重新进入编辑页')
            return
          }

          this.dialogTagType = tagType
          this.dialogVisible = true
          this.refreshingTags = true
          const done = () => { this.refreshingTags = false }

          this.$http.get('storetag/list', { params: { storeId: this.tagDialogStoreId, tagType: tagType } })
            .then(({ data: res }) => {
              if (res && res.status === 0) {
                this.applyTagList(tagType, res.list || [])
              } else {
                // 业务失败也是 HTTP 200，只能靠 status 判定
                this.$message.error((res && res.msg) || '加载标签失败')
              }
            })
            .catch(() => {
              // 不可静默：在没拉到的空池上保存会把库里真实标签全部删掉，用户必须知情
              this.$message.error('加载标签失败，请重试')
            })
            .then(done)
        },
        // 整份替换页面池：uid 原样沿用，勾选态只剔除已删除的行。
        // 不读 newList.selected（那是上次保存的旧值，会抹掉本次未保存的勾选）
        applyTagList(tagType, newList){
          const key = tagType === 1 ? 'serviceTags' : 'facilityTags'
          const uids = tagType === 1 ? 'selectedServiceUids' : 'selectedFacilityUids'

          this[key] = this.attachUid(newList || [])
          const alive = new Set(this[key].map(t => t.uid))
          this[uids] = this[uids].filter(uid => alive.has(uid))
        },
        // 弹窗保存成功（已落库）：只本地替换池子，不重拉 storeinfo，否则会冲掉页面上未保存的字段
        // tagType 必须随事件带出来，否则设施标签会覆盖服务标签池
        onTagSaved({ tagType, list }){
          this.applyTagList(tagType, list)
        },
        // 器械种类只允许正整数:输入过程中即时清洗,非数字字符(小数点/负号/字母/空格等)直接剔除,
        // 同时去掉前导 0(0 非正整数)并限制最长 9 位,与 editFormRules.devicetype 的 /^[1-9]\d{0,8}$/ 保持一致
        onlyPositiveInt(val){
          if (val === null || val === undefined) return ''
          return String(val)
            .replace(/[^\d]/g, '')
            .replace(/^0+/, '')
            .slice(0, 9)
        },
        async editStore(){
            const { data: res } = await this.$http.get('storeinfo/' + this.id )
            // 详情整份灌入 editForm；services / facilities / 两个标签池是只读数据，
            // 提交前统一 delete（见 EditStoreSave）
            this.editForm = { ...res }
            this.editForm.admin_token = window.sessionStorage.getItem('admin_token')

            // 标签池：详情接口给全量定义（含 selected），补一次 uid 后固定沿用，不再重算
            this.serviceTags = this.attachUid(res.serviceTagList || [])
            this.facilityTags = this.attachUid(res.facilityTagList || [])
            // 勾选态统一存 uid（存 id 表达不了 Add 页的 null 行，存 name 会被改名打断）
            this.selectedServiceUids = this.serviceTags.filter(t => t.selected === 1).map(t => t.uid)
            this.selectedFacilityUids = this.facilityTags.filter(t => t.selected === 1).map(t => t.uid)
            if (res.controls) {
              let arr = res.controls
              arr.forEach(item=>{
                if (item.startTime) {
                  item.startTime = new Date(item.startTime)
                  item.endTime = new Date(item.endTime)
                }
              })
              this.controls = arr
            }
            if (res.lyControls) {
              this.lyRelays = res.lyControls
              this.oldLyRelay = this.lyRelays.map(item=> item.lyKey)
            }
            if (this.editForm.openStoreTime) {
              this.editForm.openStoreTime = new Date(this.editForm.openStoreTime)
            }
            if (this.editForm.closeStoreTime) {
              this.editForm.closeStoreTime = new Date(this.editForm.closeStoreTime)
            }
            if (this.editForm.tyStartTime) {
              this.xyDates = [new Date(this.editForm.tyStartTime), new Date(this.editForm.tyStopTime)]
            }

          if (this.editForm.sn1 || this.editForm.outsn1) {
            this.closeTypes = [
              {
                val: '0',
                text: '限制进入'
              },
              {
                val: '1',
                text: '限制进出'
              }
            ]
          } else {
            this.closeTypes = [
              {
                val: '0',
                text: '限制进入'
              }
            ]
          }

            this.handleFlagChange('sign')
            this.handleControlTypeChange('sign')

            // const cityarr = []
            // cityarr.push(res.city)
            // cityarr.push(res.county)
            // this.editForm.city = cityarr
          if (res.storepic) {
            this.fileList = [{name:res.storepic,url:this.imgURL+'static/swipers/'+res.storepic}]
          }

            // this.addressChange(15)
        },
        // change(data) {
        //     this.editForm.goods_info = data;
        // },
        // editPic(file, fileList){
        //     this.editForm.storepic = file.picname
        // },


        async EditStoreSave(){
            // this.editForm.city = this.editForm.city.join(', ')
            console.log(this.editForm);
            const confirmResult = await this.$confirm('确定要保存门店的编辑吗?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            }).catch(err => err)

            if (confirmResult !== 'confirm'){
              return this.$message.info('已取消保存！')
            }

              this.$refs.editFormRef.validate( async valid=>{
                if (!valid) return

                let controls = []
                let lyControls = []
                if (this.editForm.newFlag === "Y") {
                  let ipValid = /^(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3}):(\d{1,6})$/
                  let sign = 0
                  if (this.controls.length === 0 && this.editForm.isopen == '1') {
                    this.$message.error('新设备不可以不添加继电器！');
                    return
                  }
                  this.controls.forEach((control, index) => {
                    let obj = {...control};
                    if (!control.name) {
                      obj.name = '继电器' + (index + 1)
                    }
                    if (control.relayNum == null) {
                      sign = 1
                    }
                    if (control.autoType === '0') {
                        if (!control.startTime) {
                          sign = 2
                        } else {
                          obj.startTime = control.startTime.getTime()
                        }
                        if (!control.endTime) {
                          sign = 6
                        } else {
                          obj.endTime = control.endTime.getTime()
                        }
                    }
                    controls.push(obj)
                  })
                  if (sign === 2) {
                    this.$message.error('继电器定时开启不可以不设置开启时间！');
                    return
                  } else if (sign === 6) {
                    this.$message.error('大厅继电器定时开启不可以不设置关闭时间！');
                    return
                  } else if (sign === 1) {
                    this.$message.error('继电器不可以不设置端口！');
                    return
                  }
                  this.editForm.controls = controls

                  if (this.lyRelays.length === 0 && this.editForm.isopen == '1') {
                    this.$message.error('新设备不可以不添加淋浴继电器！');
                    return
                  }
                  this.lyRelays.forEach((control) => {
                    if (!control.lyIp) {
                      sign = 3
                    } else if (!ipValid.test(control.lyIp)) {
                      sign = 4
                    }
                    lyControls.push(control)
                  })

                  if (sign === 3) {
                    this.$message.error('淋浴继电器必须设置IP地址！');
                    return
                  }else if (sign === 4) {
                    this.$message.error('淋浴继电器IP地址格式不对，格式IP:PORT！');
                    return
                  }

                  this.editForm.lyControls = lyControls
                }

                let obj = {...this.editForm}
                // 以下键不提交（后端 <if test="x != null"> 会跳过，旧值保留）：
                //   facilityList / services / facilities —— 两列已作废；facilityList 原样回传会触发
                //     后端 syncStoreFacility 重写关联表
                //   serviceTagList / facilityTagList —— 库字段，池子由 /storetag/save 维护，
                //     门店保存只提交下面的勾选态 id 数组
                // 不传即后端 <if test="x != null"> 跳过，旧值原样保留，不会被写成空串
                delete obj.facilityList
                delete obj.services
                delete obj.facilities
                delete obj.serviceTagList
                delete obj.facilityTagList
                if (obj.openStoreTime) {
                  obj.openStoreTime = obj.openStoreTime.getTime()
                }
                if (obj.closeStoreTime) {
                  obj.closeStoreTime = obj.closeStoreTime.getTime()
                }

                obj.updateSign = this.updateSign
                if (this.oldLyRelay) {
                  obj.oldLyRelay = this.oldLyRelay
                }

                if (this.xyDates && this.xyDates.length > 0) {
                  obj.tyStartTime = this.xyDates[0].getTime()
                  obj.tyStopTime = this.xyDates[1].getTime()
                } else {
                  obj.tyStartTime = null
                  obj.tyStopTime = null
                }

                // 标签勾选态：只提交 id 数组。空数组 = 全部取消勾选（合法）；null 才表示不提交
                obj.serviceTagIds = this.selectedServiceUids
                  .map(uid => this.serviceTags.find(t => t.uid === uid))
                  .filter(t => t && t.id != null)
                  .map(t => t.id)
                obj.facilityTagIds = this.selectedFacilityUids
                  .map(uid => this.facilityTags.find(t => t.uid === uid))
                  .filter(t => t && t.id != null)
                  .map(t => t.id)

                if (!obj.managerNum) {
                  obj.managerNum = null
                }
                if (!obj.ownerNum) {
                  obj.ownerNum = null
                }
                if (!obj.associateNum) {
                  obj.associateNum = null
                }
                if (!obj.clearNum) {
                  obj.clearNum = null
                }
                if (!obj.settingNum) {
                  obj.settingNum = null
                }


                this.btnLoading = true
                const { data:res } = await this.$http.post('storeedit/'+this.id,obj)
                this.btnLoading = false
                if(res.status===0)
                {
                    this.$message.success('修改门店成功！')
                    // 使用完全刷新的方式返回门店列表，确保组件完全卸载并重新加载
                    window.location.href = '#/stores'
                } else {
                  this.$message.error(res.message);
                }
              })
       },
      handleFlagChange(val) {
        if (val == 'flag') {
          this.editForm.controlType = '0'
          this.editForm.upDeviceTopic = null
          this.editForm.upDeviceTopic2 = null
          this.editForm.lyTime = null
          this.controls = []
          this.lyRelays = []
        }

        if (val == 'isopen') {
          this.xyDates = []
        }

        this.editFormRules.upDeviceTopic = []
        this.editFormRules.lyTime = []
        // this.editFormRules.doorIp = [
        //   { pattern: /^(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3}):(\d{1,6})$/, message: 'IP格式IP:PORT', trigger: 'blur' }
        // ]
        if (this.editForm.isopen == '1' && this.editForm.newFlag === 'Y') {
          this.editFormRules.upDeviceTopic = [
            { required: true, message: '请输入上位机TOPIC', trigger: 'change' },
            { max: 50, message: '最大长度为50字符', trigger: 'change' }
          ]
          this.editFormRules.lyTime = [
            { required: true, message: '请输入淋浴时长', trigger: 'change' },
            { pattern: /^[1-9]|([1,2]\d)|30$/, message: '淋浴时长最小1最大30', trigger: 'blur' }
          ]
          // this.editFormRules.doorIp = [
          //   { required: true, message: '请输入AB门ip', trigger: 'change' },
          //   { pattern: /^(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3}):(\d{1,6})$/, message: 'IP格式IP:PORT', trigger: 'blur' }
          // ]
        }
      },
      handleControlTypeChange(val) {
        if (val != 'sign') {
          this.editForm.controlIp = null
        }
        this.editFormRules.controlIp = [
          { pattern: /^(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3}):(\d{1,6})$/, message: 'IP格式IP:PORT', trigger: 'blur' }
        ]
        if (this.editForm.controlType == '1') {
          this.editFormRules.controlIp = [
            { required: true, message: '请输入泥人IP', trigger: 'change' },
            { pattern: /^(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3}):(\d{1,6})$/, message: 'IP格式IP:PORT', trigger: 'blur' }
          ]
        }
      },
      handleCancel() {
        // 使用完全刷新的方式导航到添加门店页面
        window.location.href = '#/stores'
      },
      handleDeleteRelay(index) {
        this.controls.splice(index, 1)
      },
      handleAddRelay(){
        if (this.editForm.controlType == '1') {
          if (this.controls.length < 8) {
            this.controls.push({
              relayNum: null,
              name: null,
              autoFlag: '1',
              autoType: '1',
              dsTimeArr: null
            })
          } else {
            this.$message.error('最多只能增加8个继电器端口哦');
          }
        } else {
          if (this.controls.length < 16) {
            this.controls.push({
              relayNum: null,
              name: null,
              autoFlag: '1',
              autoType: '1',
              dsTimeArr: null
            })
          } else {
            this.$message.error('最多只能增加16个继电器端口哦');
          }
        }
      },
      handleAutoChange(row){
        if (row.autoFlag === '0') {
          row.autoType = null
        } else {
          row.autoType = '1'
        }
        row.dsTimeArr = null
      },
      handleAutoTypeChange(row){
        if (row.autoType === '1') {
          row.startTime = null
          row.endTime = null
        }
      },
      handleAddLy() {
        this.lyRelays.push({
          lyIp: "127.0.0.1:520" + this.lyRelays.length,
          lyKey: this.generateUUID(),
          editFlag: 'Y'
        })
        this.updateSign = true
      },
      handleDelLy(i) {
        this.updateSign = true
        this.lyRelays.splice(i, 1)
      },
      generateUUID() {
        let timestamp = new Date().getTime();
        return 'xxxxxxxx'.replace(/[xy]/g, function (c) {
          const r = (timestamp + Math.random() * 16) % 16 | 0;
          timestamp = Math.floor(timestamp / 16);
          return (c === 'x' ? r : (r & 0x3 | 0x8)).toString(16);
        });
      },
      editPic(file, fileList){
        this.editForm.storepic = file.picname
      },
      // 上传前校验：仅允许 jpg/png，且不超过 2M（返回 false 时 el-upload 会终止上传）
      beforePicUpload(file) {
        const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
        const isLt2M = file.size / 1024 / 1024 < 2;
        if (!isJpgOrPng) {
          this.$message.error('只能上传 JPG/PNG 格式的图片!');
        }
        if (!isLt2M) {
          this.$message.error('上传图片大小不能超过 2MB!');
        }
        return isJpgOrPng && isLt2M;
      },
      handleZhapaiChange(val) {
        this.editFormRules.lxjIp = [
          { pattern: /^(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3})$/, message: 'IP格式XXX.XXX.XXX', trigger: 'blur' }
        ]
        this.editFormRules.zhuapaiNum = [
          { pattern: /^[1-9]\d{0,8}$/, message: '抓拍数量只能是数字必须以1-9开头', trigger: 'blur' }
        ]
        this.editForm.lxjIp = null
        this.editForm.zhuapaiNum = null
        this.editForm.camera1 = null
        this.editForm.camera2 = null
        this.editForm.camera3 = null
        this.editForm.camera4 = null
        if (val === '1') {
          this.editFormRules.lxjIp = [
            { required: true, message: '请选输入录像机IP', trigger: 'blur' },
            { pattern: /^(\d{1,3})\.(\d{1,3})\.(\d{1,3})\.(\d{1,3})$/, message: 'IP格式XXX.XXX.XXX', trigger: 'blur' }
          ]
          this.editFormRules.zhuapaiNum = [
            { required: true, message: '请选输入抓拍数量', trigger: 'blur' },
            { pattern: /^[1-9]\d{0,8}$/, message: '抓拍数量只能是数字必须以1-9开头', trigger: 'blur' }
          ]
        }
      },
      handleOpenStoreTime() {
        if (!this.editForm.closeStoreTime && !this.editForm.openStoreTime) {
          this.editForm.closeStatus = null
          this.editForm.openDoor = null
        } else {
          if (!this.editForm.closeStatus) {
            this.editForm.closeStatus = '0'
            this.editForm.openDoor = null
          }
        }
      },
      handleTwoDoorChange(val) {
        if (this.editForm.sn1 || this.editForm.outsn1) {
          this.closeTypes = [
            {
              val: '0',
              text: '限制进入'
            },
            {
              val: '1',
              text: '限制进出'
            }
          ]
        } else {
          this.closeTypes = [
            {
              val: '0',
              text: '限制进入'
            }
          ]

          if (this.editForm.closeStoreTime || this.editForm.openStoreTime) {
            this.editForm.closeStatus = '0'
            this.editForm.openDoor = null
          }
        }
      },
      handleCloseStatusChange() {
        this.editForm.openDoor = null
      }
    }
}
</script>
<style scoped>
    .cardcss{
        margin: 5px auto ;
        width: 100%;
    }
    .el-breadcrumb{
        width: 100%;
    }

    /* 备注文本域：标签与多行输入框精确垂直居中，去掉悬空感 */
    .remark-item {
        display: flex;
        align-items: center;
    }
    .remark-item ::v-deep .el-form-item__label {
        float: none;
        line-height: normal;
        padding-bottom: 0;
    }
    .remark-item ::v-deep .el-form-item__content {
        flex: 1;
        margin-left: 0 !important;
    }
    .remark-item ::v-deep .el-textarea__inner {
        resize: none;
        line-height: 1.6;
    }
    .remark-item ::v-deep .el-input__count {
        background: transparent;
        color: #c0c4cc;
        line-height: 20px;
        bottom: 4px;
        right: 10px;
    }

    /* 表单工整度：仅作用于本表单（style 无 scoped，避免污染全局） */
    .store-form .el-checkbox {
        margin-right: 14px;
    }
    .store-form .el-checkbox:last-child {
        margin-right: 0;
    }
    .store-form .el-radio {
        margin-right: 16px;
    }
    .store-form .el-form-item__content {
        /* 纯文本字段（如门店名称）与 32px 输入框基线对齐 */
        line-height: 32px;
    }

    /* 自定义标签：10 个一组切行，组内放不下继续换行（style 无 scoped，必须带 .store-form 前缀） */
    .store-form .tag-row {
        display: flex;
        flex-wrap: wrap;
        align-items: center;
    }
    /* Element 给 .el-checkbox-group 设了 font-size:0 吃掉行内空白，这里的 font-size 不能省 —— 省了「暂未提供」直接消失 */
    .store-form .tag-empty {
        font-size: 12px;
        color: #999;
        margin-right: 12px;
    }
    .store-form .tag-manage-btn {
        padding: 0;
        font-size: 14px;
    }
</style>
